<template>
  <div class="activityWarp">
    <van-pull-refresh v-model="isLoading" @refresh="pullDownRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="upLoad"
      >
        <div class="card" v-for="item in activityList" :key="item.id">
          <div class="left">
            <div class="reduce_money">￥{{ item.consumer_reduce_money }}</div>
            <div class="p">满{{ item.consumer_full_money }}元可用</div>
          </div>
          <div class="center">
            <div class="title">
              <span class="type">{{ item.title }}</span>
              <span class="store_name">{{ item.store_name }}</span>
            </div>

            <div class="date">{{ item.get_end_date }}到期</div>
          </div>
          <div class="right">
            <div class="title">发放数量</div>
            <div class="num">{{ item.num }}</div>
            <div class="detail" @click="toDetail(item)">查看详情</div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
export default {
  namr: "activity",
  props: {
    merchant_id: Number,
  },
  data() {
    return {
      page: 0,
      limit: 10,
      activityList: [],
      loading: false,
      finished: false,
      isLoading:false
    };
  },
  mounted() {
    this.pullDownRefresh();
  },
  methods: {
    getMerchantCouponsList() {
      console.log("请求列表666");
      var reqData = {
        salesman_id: this.$cookie.get("salesmanInfo").id,
        page: this.page,
        limit: this.limit,
        merchant_id: this.merchant_id,
      };
      this.$http 
        .get("/wechat/api.salesman/merchantCoupons", { params: reqData })
        .then((res) => {
          console.log(res.body.data);
          this.count = res.body.data.count;
          console.log(this.activityList);
          // this.activityList.push(res.body.data.rows);
          res.body.data.rows.map(v=>{
            this.activityList.push(v)
          })
          console.log(this.activityList);
          this.isLoading=false;
          this.loading = false;
          if (this.activityList.length >= res.body.data.count) {
            this.finished = true;
          }
        });
    },
    toDetail(item) {
      // var params = JSON.stringify(item);
      this.$router.push({
        path: "/cardDetail",
        query: item,
      });
    },
    // 下拉刷新
    pullDownRefresh() {
      console.log("下拉刷新666");
      this.page = 0;
      this.activityList = [];
      this.finished = false;
      this.loading = true;
      this.getMerchantCouponsList();
    
    },
    // 上拉触底加载
    upLoad() {
      this.page++;
      this.isLoading=true;
      this.getMerchantCouponsList();
    },
  },
};
</script>
<style scoped>
.activityWarp {
  padding-top: 5px;
  font-size:12px;
}
.card {
  width: 94%;
  /* height: 120px; */
  margin: 0px auto;
  margin-bottom: 5px;
  border-radius: 5px;
  border: 1px solid #ccc;
  /* padding:0px 0px 10px 0px; */
  /* box-shadow: ; */
  display: flex;
}
.card .left {
  flex: 2;
  text-align: center;
  /* display: flex; */
  flex-wrap: wrap;
  align-items: center;
  border-right: 1px dotted #ccc;
}

.card .left .reduce_money {
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 20px;
  /* margin-bottom: 10px; */
  color: red;
}
.card .left .p {
  width: 100%;
  height: 30px;
  line-height: 30px;
  color: #333;
  font-size: 0.25rem;
  /* margin-bottom:10px; */
}
.card .center {
  /* text-align: center; */
  flex: 4;
  margin: 0 10px;
  border-right: 1px dotted #ccc;
}
.card .center .title {
  height: 40px;
  line-height: 40px;
  overflow: hidden;
  /* margin-bottom: 10px; */
}
.card .center .title .type {
  display: inline-block;
  padding: 5px 5px;
  font-size: 10px;
  height: 10px;
  line-height: 10px;
  background-color: yellow;
  margin-right: 5px;
  vertical-align: top;
  margin-top: 10px;
}
.card .center .title .store_name {
  font-size: 14px;
  font-weight: 600;
  /* margin-bottom:10px; */
}
.card .center .date {
  height: 30px;
  line-height: 30px;
}
.card .right {
  /* display: flex; */
  /* align-items: center; */
  text-align: center;
  flex: 2;
}
.card .right div {
  height: 20px;
}
.card .right .title {
  margin-top: 5px;
}
.card .right .detail {
  margin-bottom: 5px;
  color: #ff7926;
  cursor: pointer;
}
</style>